import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_CIC_ALERT_DETAILS_REQUEST = 'GET_CIC_ALERT_DETAILS_REQUEST';
export const GET_CIC_ALERT_DETAILS_SUCCESS = 'GET_CIC_ALERT_DETAILS_SUCCESS';
export const GET_CIC_ALERT_DETAILS_FAILURE = 'GET_CIC_ALERT_DETAILS_FAILURE';
export const GET_CIC_ALERT_DETAILS_CLEAR = 'GET_CIC_ALERT_DETAILS_CLEAR';

function request(cicAlertId, rowId) {
  return {
    type: GET_CIC_ALERT_DETAILS_REQUEST,
    rowId,
    cicAlertId
  };
}

function receive(cicAlertDetails, cicAlertId, rowId) {
  return {
    type: GET_CIC_ALERT_DETAILS_SUCCESS,
    cicAlertId,
    rowId,
    cicAlertDetails
  };
}

function reject(cicAlertId, rowId, getCicAlertDetailsError) {
  return {
    type: GET_CIC_ALERT_DETAILS_FAILURE,
    cicAlertId,
    rowId,
    getCicAlertDetailsError
  };
}

function clear(cicAlertId, rowId) {
  return {
    type: GET_CIC_ALERT_DETAILS_CLEAR,
    cicAlertId,
    rowId
  };
}

export function getCicAlertDetails(cicAlertId, rowId) {
  return (dispatch) => {
    dispatch(request(cicAlertId, rowId));
    return ApiService
      .getCicAlertDetails(cicAlertId)
      .then((response) => {
        dispatch(receive(response.data, cicAlertId, rowId));
      }).catch((error) => {
        if (error && error.response) {
          error.response.data = { code: error.response.status, message: 'Sorry, we were unable to retrieve your CIC alert details at this time, please try again later' };
        }
        dispatch(handleException(error, null, true));
        dispatch(reject(cicAlertId, rowId, error.response.data));
      });
  };
}

export function clearCicAlertDetails(cicAlertId, rowId) {
  return (dispatch) => {
    dispatch(clear(cicAlertId, rowId));
  };
}
